const styles = `:host {
  display: inline-flex;
  position: relative;
}
:host .popover {
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: var(--goto-ui-01);
  border-color: var(--goto-popover-border-color);
  box-shadow: var(--goto-popover-elevation);
  padding: var(--goto-spacing-04);
  color: var(--goto-text-01);
  display: block;
  left: 0;
  position: fixed;
  opacity: 0;
  top: 0;
  visibility: hidden;
}
:host .popover::before, :host .popover::after {
  border-width: 1px;
  border-style: solid;
  display: none;
  position: absolute;
  content: "";
  border-color: transparent;
  pointer-events: none;
  position: fixed;
}
:host .popover::before {
  border-width: 9px;
  top: var(--caret-shadow-top-position);
  left: var(--caret-shadow-left-position);
}
:host .popover::after {
  border-width: 8px;
  top: var(--caret-top-position);
  left: var(--caret-left-position);
}
:host .popover.visible {
  opacity: 1;
  visibility: visible;
}
:host .popover.large {
  padding: 24px;
}
:host ::slotted([slot=content]) {
  border-radius: 4px;
  word-break: break-word;
}
:host ::slotted([slot=trigger]:not([disabled])) {
  cursor: pointer;
}
:host .hidden {
  display: none;
}

:host([arrow]) .popover::before {
  display: inline-block;
}
:host([arrow]) .popover::after {
  display: inline-block;
}

:host([menu]) .popover {
  padding: var(--goto-spacing-00);
}

:host([compact]) .popover {
  padding: var(--goto-spacing-02);
}

:host([inverted]) .popover {
  background-color: var(--goto-neutral);
  border-color: var(--goto-neutral);
  color: var(--goto-text-04);
}

:host([caret=top-start]) .popover::before,
:host([caret=top-center]) .popover::before,
:host([caret=top-end]) .popover::before {
  border-top-color: var(--goto-border);
}
:host([caret=top-start]) .popover::after,
:host([caret=top-center]) .popover::after,
:host([caret=top-end]) .popover::after {
  border-top-color: var(--goto-ui-01);
}

:host([caret=bottom-start]) .popover::before,
:host([caret=bottom-center]) .popover::before,
:host([caret=bottom-end]) .popover::before {
  border-bottom-color: var(--goto-border);
}
:host([caret=bottom-start]) .popover::after,
:host([caret=bottom-center]) .popover::after,
:host([caret=bottom-end]) .popover::after {
  border-bottom-color: var(--goto-ui-01);
}

:host([caret=left-start]) .popover::before,
:host([caret=left-center]) .popover::before,
:host([caret=left-end]) .popover::before {
  border-left-color: var(--goto-border);
}
:host([caret=left-start]) .popover::after,
:host([caret=left-center]) .popover::after,
:host([caret=left-end]) .popover::after {
  border-left-color: var(--goto-ui-01);
}

:host([caret=right-start][inverted]) .popover::before,
:host([caret=right-center][inverted]) .popover::before,
:host([caret=right-end][inverted]) .popover::before {
  border-right-color: var(--goto-neutral);
}
:host([caret=right-start][inverted]) .popover::after,
:host([caret=right-center][inverted]) .popover::after,
:host([caret=right-end][inverted]) .popover::after {
  border-right-color: var(--goto-neutral);
}

:host([caret=top-start][inverted]) .popover::before,
:host([caret=top-center][inverted]) .popover::before,
:host([caret=top-end][inverted]) .popover::before {
  border-top-color: var(--goto-neutral);
}
:host([caret=top-start][inverted]) .popover::after,
:host([caret=top-center][inverted]) .popover::after,
:host([caret=top-end][inverted]) .popover::after {
  border-top-color: var(--goto-neutral);
}

:host([caret=bottom-start][inverted]) .popover::before,
:host([caret=bottom-center][inverted]) .popover::before,
:host([caret=bottom-end][inverted]) .popover::before {
  border-bottom-color: var(--goto-neutral);
}
:host([caret=bottom-start][inverted]) .popover::after,
:host([caret=bottom-center][inverted]) .popover::after,
:host([caret=bottom-end][inverted]) .popover::after {
  border-bottom-color: var(--goto-neutral);
}

:host([caret=left-start][inverted]) .popover::before,
:host([caret=left-center][inverted]) .popover::before,
:host([caret=left-end][inverted]) .popover::before {
  border-left-color: var(--goto-neutral);
}
:host([caret=left-start][inverted]) .popover::after,
:host([caret=left-center][inverted]) .popover::after,
:host([caret=left-end][inverted]) .popover::after {
  border-left-color: var(--goto-neutral);
}

:host([caret=right-start][inverted]) .popover::before,
:host([caret=right-center][inverted]) .popover::before,
:host([caret=right-end][inverted]) .popover::before {
  border-right-color: var(--goto-neutral);
}
:host([caret=right-start][inverted]) .popover::after,
:host([caret=right-center][inverted]) .popover::after,
:host([caret=right-end][inverted]) .popover::after {
  border-right-color: var(--goto-neutral);
}`; export default styles;